import { defineStore } from 'pinia'

// 1. Εισάγουμε το function-based service
import { useLeadService } from 'src/services/ProgrammeLeadService'
import type { LeadCreate } from 'src/types/Lead'

export const useLeadStore = defineStore('lead', {
  state: () => ({
    isSaving: false,
  }),
  actions: {
    async registerInterest(data: LeadCreate) {
      this.isSaving = true
      const leadService = useLeadService()

      try {
        await leadService.saveLead(data)
      } catch (error) {
        console.error('Error submitting lead:', error)
        throw error
      } finally {
        this.isSaving = false
      }
    },
  },
})
